const PERMISSIONS_STORAGE_KEY = 'permissions'

function normalisePermissions(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {}
  }

  const map = {}
  Object.keys(raw).forEach((key) => {
    if (raw[key]) {
      map[key] = true
    }
  })
  return map
}

export function setStoredPermissions(permissions) {
  const map = normalisePermissions(permissions)
  localStorage.setItem(PERMISSIONS_STORAGE_KEY, JSON.stringify(map))
  return map
}

export function getStoredPermissions() {
  const raw = localStorage.getItem(PERMISSIONS_STORAGE_KEY)
  if (!raw) {
    return {}
  }

  try {
    return normalisePermissions(JSON.parse(raw))
  } catch (error) {
    return {}
  }
}

export function clearStoredPermissions() {
  localStorage.removeItem(PERMISSIONS_STORAGE_KEY)
}

export function can(permission, permissions = getStoredPermissions()) {
  if (!permission) {
    return true
  }
  return Boolean(permissions && permissions[permission])
}
